export function querySelect() {
    const _window = this._window;
    const _document = this._document;
    const querySelects = _document.querySelectorAll(".query-select");

    [...querySelects].forEach(select => {
        select.addEventListener("change", () => {
            let pageURL = _window.location.href;
            const cleanPageURL = pageURL.substr(0, pageURL.indexOf("?"));
            _window.location.href = `${cleanPageURL}?${select.value}`;
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/querySelect.js